var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCopyRefer = function SvgIconCopyRefer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M9.666 7.6v2.8c0 2.333-.933 3.267-3.266 3.267H3.6c-2.334 0-3.267-.934-3.267-3.267V7.6c0-2.333.933-3.267 3.267-3.267h2.8c2.333 0 3.266.934 3.266 3.267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M10.4.333H7.6c-2.055 0-3.02.73-3.22 2.493-.042.369.263.674.635.674H6.4c2.8 0 4.1 1.3 4.1 4.1v1.385c0 .372.305.677.674.635 1.763-.2 2.493-1.165 2.493-3.22V3.6c0-2.333-.934-3.267-3.267-3.267"
  })));
};
export default SvgIconCopyRefer;